// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import echarts from 'echarts'
import 'echarts-liquidfill'
import 'babel-polyfill'
import MessageBox from '@/components/message'
import * as filters from './filters'
import * as utils from './utils'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import WebsocketHeartbeatJs from 'websocket-heartbeat-js'
import countTo from 'vue-count-to'

import '@/permission' // 权限控制


// 引入基本模板
let echarts = require('echarts/lib/echarts')

// 按需引入echart折线图等组件
require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/gauge')
require('echarts/lib/chart/pictorialBar')
require('echarts/lib/chart/radar')

// 按需引入echart提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')// 图例翻译滚动
require('echarts/lib/component/polar')

// 本地引入字体库文件
require('./assets/font/iconfont.css')
require('./assets/less/index.less')
Vue.prototype.$echarts = echarts
Vue.prototype.$superMessage = MessageBox
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.component('countTo', countTo)
// 实例化Vue的filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
Vue.prototype.$utils = utils
// 全局注册api接口方法
const Request = require.context('./api', true, /\.js$/)
let requestList = {}
Request.keys().forEach(v => {
  let requestObj = {...Request(v)}
  requestList = Object.assign(requestList, requestObj)
})
Vue.prototype.$request = requestList
// 全局注册componenets文件夹下组件（false为不包含子文件夹）
const context = require.context('./components', true, /\.vue$/)
context.keys().forEach(v => {
  let component = context(v).default
  Vue.component(component.name, component)
})
window.webSocket = new WebsocketHeartbeatJs({url: SERVERCONFIG.VUE_APP_SOCKET_API})
// window.webSocket.onopen = function () {
//   console.log('connect success')
// }
// window.webSocket.onmessage = function () {
//   // console.log(`onmessage: ${e.data}`)
// }
// window.webSocket.onreconnect = function () {
//   console.log('reconnecting...')
// }
// router.beforeEach((to, from, next) => {
//   let loginInfo = window.sessionStorage.getItem('loginInfo')
//   console.log(loginInfo, '222222')
//   if (to.meta.title) {
//     document.title = to.meta.title
//   }
//   const type = to.meta.type
// // 判断该路由是否需要登录权限
//   if (type === 'login') {
//     console.error(typeof window.localStorage.getItem('isLogin'))
//     if (window.localStorage.getItem('isLogin')) {
//       next()
//     } else {
//       next('/login')
//     }
//   } else {
//     next() // 确保一定要有next()被调用
//   }
// })

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js